import _default from './Segment';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/es/elements/Segment/index.js
// module id = 1569
// module chunks = 0